<div class="stripe-dialog">
  <!-- Material Dialog Header with proper close button -->
  <div class="stripe-dialog__header">
    <h2 mat-dialog-title class="stripe-dialog__title">Bruce's</h2>
    <button
      mat-icon-button
      class="stripe-dialog__close-btn"
      (click)="closeDialog()"
      aria-label="Close dialog">
      <mat-icon svgIcon="close_icon"></mat-icon>
    </button>
  </div>

  <!-- Material Dialog Content -->
  <mat-dialog-content class="stripe-dialog__content">
    <p class="stripe-dialog__subtitle mat-body-medium">
      Extra fees charged for card payments
    </p>

    @if (!hasData) {
      <div class="stripe-dialog__loading">
        <mat-spinner color="primary" diameter="50"></mat-spinner>
      </div>
    }

    <form id="payment-form" class="stripe-dialog__form">
      <div class="stripe-dialog__card-input-wrapper">
        <mat-icon svgIcon="lock_icon" color="primary" class="stripe-dialog__lock-icon"></mat-icon>
        <div class="stripe-dialog__card-element-container">
          <div id="card-element"></div>
        </div>
      </div>

      <div class="stripe-dialog__errors mat-body-medium" id="card-errors" role="alert"></div>
    </form>
  </mat-dialog-content>

  <!-- Material Dialog Actions -->
  <mat-dialog-actions class="stripe-dialog__actions" align="center">
    @if (loading) {
      <div class="stripe-dialog__loading">
        <mat-spinner color="primary" diameter="50"></mat-spinner>
      </div>
    } @else {
      <button
        mat-raised-button
        color="primary"
        class="stripe-dialog__checkout-btn"
        type="submit"
        form="payment-form">
        CHECKOUT &pound;{{total}}
      </button>
    }
  </mat-dialog-actions>
</div>